import { render, staticRenderFns } from "./fvHeader.vue?vue&type=template&id=09a0cf7c&lang=pug&"
var script = {}
import style0 from "./fvHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvHeader.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvHeader.vue
// module id = 89
// module chunks = 0 1